<div class=' mw-full t-c m-l-a m-r-a' [class]="(data.type=='renewal_expire' || data.type=='renewal') ? 'w-renewal':'w-400'">
    <div class='p-20 t-l' *ngIf="data.type=='renewal_expire'">
        <!--div >
            <img style="float:right;cursor: pointer;" src="https://songdew.com/close.1c273cc3db2299af48e3.svg" alt="Close"
        (click)="closeDialog()">
     </!div -->
     <div class='renewal-msg'>Your subscription has expired!</div>
     <!--div class='renewal-msg m-t-5'>Renew Today And Get 20% Off</!div -->
        <div style="text-align: center;" > <img  src="../assets/image/renewal/expired.png" class="renewal-img"></div>
        
        <div style="text-align: center;"><button class='m-t-20 m-b-20 renew-button ' (click)="closeDialog();global.trackEvent('renewal_expire', 'popup_click');" routerLink="/subscription/songdew-pro">Renew Now</button></div>
    </div>
    <div class='p-20 t-l' *ngIf="data.type=='renewal'">
        <!--div >
            <img style="float:right;cursor: pointer;" src="https://songdew.com/close.1c273cc3db2299af48e3.svg" alt="Close"
        (click)="closeDialog()">
     </!div -->
     <div class='renewal-msg'>Your subscription is expiring soon!</div>
     <div class='renewal-msg m-t-5'>Renew Today And Get 20% Off</div>
        <div style="text-align: center;"> <img  src="../assets/image/renewal/expiring.png" class="renewal-img"></div>
        
        <div style="text-align: center;"><button class='m-t-20 m-b-20 renew-button ' (click)="closeDialog();global.trackEvent('renewal', 'popup_click');" routerLink="/subscription/songdew-pro">Renew Now</button></div>
    </div>
    <div class='p-20 t-l' *ngIf="data.type=='opp_save'">
        <div class='strong f16'>Opportunity Saved</div>
        <div class='m-t-20 grey'> Yellow! You will be notified via email 48 hours before this opportunity ends.
            You can also access all your Saved Opportunities on <a class='linkBlue'
                routerLink="/mydashboard/opportunities" (click)="closeDialog()">My Opportunities Page</a></div>
                <button class='m-t-20' (click)="closeDialog()">OK, got it</button>
    </div>
    <div class='p-20 t-l' *ngIf="data.type=='opp_save_soon'">
        <div class='strong f16'>Opportunity Saved</div>
        <div class='m-t-20 grey'> Yellow! This opportunity ends in 1 day
            You can access it on <a class='linkBlue' routerLink="/mydashboard/opportunities" (click)="closeDialog()">My
                Opportunities Page</a>. Hurry up and complete your participation before the due date!</div>
                <button class='m-t-20' (click)="closeDialog()">OK, got it</button>
    </div>
    <div class='p-20 t-l' *ngIf="data.type=='opp_notify'">
        <div class='strong f16'>Congratulations! You caught this one early!</div>
        <div class='m-t-20 grey'> Hey There! This opportunity is all set to launch in just a few days! You are going to
            be the first one we notify. Stay Tuned :) (and keep a tab on your emails)</div>
        <button class='m-t-20' (click)="closeDialog()">OK, got it</button>
    </div>


    <div class="p-b-20 row d-flex justify-content-center" *ngIf="data.type=='dashboard'">
    <div class="col-lg-12">
            <img style="float:right;cursor: pointer;" src="https://songdew.com/close.1c273cc3db2299af48e3.svg" alt="Close"
        (click)="closeDialog()">
     </div>

        <div class="col-lg-10">
            <p>{{data.tool}}</p>
            <button (click)="uploadMore(data.isReleased);closeDialog();">{{data.isReleased?'Distribute':'Upload'}}</button>
        </div>

    </div>


</div>
